import React from "react";
import PropTypes from "prop-types";

class Skill extends React.Component {
  change = e => {
    const { skill, onChange } = this.props;
    onChange(skill.id || skill._id, e.target.value);
  };

  remove = () => {
    const { skill, onDelete } = this.props;
    onDelete(skill.id || skill._id);
  };

  render() {
    const { skill } = this.props;

    return (
      <div className="row">
        <div className="col-sm-9">
          <input
            className="form-control"
            value={skill.name}
            onChange={this.change}
            title="Add Skill"
          />
        </div>
        <div className="col-sm-3 mb-15">
          <button
            className="btn btn-grey btn-raised btn-block"
            onClick={this.remove}
          >
            REMOVE SKILL
          </button>
        </div>
      </div>
    );
  }
}

Skill.propTypes = {
  skill: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  onDeleteSkill: PropTypes.func
};

export default Skill;
